import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EarOffIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6.03001 3.19997C7.15001 2.43997 8.51001 1.99997 10 1.99997C13.93 1.99997 17 5.06997 17 8.99997C17 10.26 16.62 11.65 15.93 12.9C15.91 12.94 15.88 12.98 15.85 13.03L14.37 11.55C14.77 10.69 15 9.79997 15 8.99997C15 6.19997 12.8 3.99997 10 3.99997C9.08001 3.99997 8.24002 4.25997 7.50001 4.66997L6.03001 3.19997ZM17.21 14.38L18.64 15.81C20.11 13.93 21 11.57 21 8.99997C21 5.95997 19.77 3.20997 17.78 1.21997L16.36 2.63997C17.99 4.25997 19 6.50997 19 8.99997C19 11.02 18.33 12.88 17.21 14.38ZM10 6.49997C9.79001 6.49997 9.60001 6.52997 9.41001 6.57997L12.42 9.58997C12.47 9.39997 12.5 9.20997 12.5 8.99997C12.5 7.61997 11.38 6.49997 10 6.49997ZM21.19 21.19L2.81001 2.80997L1.39001 4.21997L3.52001 6.34997C3.19001 7.15997 3.00001 8.04997 3.00001 8.99997H5.00001C5.00001 8.63997 5.05001 8.28997 5.12001 7.94997L11.73 14.56C10.85 15.24 9.95001 15.97 9.46001 17.46C8.96001 18.96 8.46001 19.47 7.75001 19.84C7.56001 19.94 7.29001 20 7.00001 20C5.90001 20 5.00001 19.1 5.00001 18H3.00001C3.00001 20.21 4.79001 22 7.00001 22C7.57001 22 8.13002 21.88 8.64002 21.65C10 20.94 10.77 19.92 11.37 18.1C11.69 17.12 12.27 16.67 13.08 16.05C13.11 16.03 13.13 16.01 13.16 15.99L19.78 22.61L21.19 21.19Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
